;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('templateItem', templateItem)

  /* @ngInject */
  function templateItem () {
    return {
      restrict: 'E',
      scope: {
        template: '<',
        change: '&',
        options: '<',
        actions: '<',
        square: '<',
        showSize: '<',
        checkbox: '<',
        folders: '<',
        view: '<',
        loading: '=',
        templateParam: '=',
        showPreviewButton: '<',
        showCustomizableTag: '<?',
        showOpenFileLocation: '<',
        previewSelect: '<',
        getPreviewAssets: '<',
        handleOpenQuickPreview: '&',
        arts: '<',
        location: '<',
        selectedTemplates: '<',
        selectedCollections: '<',
        isSearch: '=',
        selectType: '=',
        selected: '=',
        onCardClick: '&',
        fromCampaignAction: '<',
        shouldDragCards: '<',
        isProductList: '=',
        disabled: '<',
        isPublicCampaign: '=',
        linkUuid: '=',
        allTemplates: '='
      },
      templateUrl: '/arts/directives/template-item/template-item-directive.html?$$REVISION$$',
      controller: 'TemplateItemController'
    }
  }
})()
